// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper___U58E","title":"ClientInsurance_title__1uISz","itemText":"ClientInsurance_itemText__15u84"};